import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  MISformP1,
  MISformP2,
  MISformP3,
  MISformP4,
  MISformP5,
  MISformP6,
  MISformP7,
  MISformP8,
  MISformP9,
  MISformP10,
  MISformP11,
  MISformP12,
  MISformP13,
  MISformP14,
  MISformP15,
  MISformP16,
  MISformP17,
  MISformP18,
  MISformP19,
  MISformP20,
  MISformP21,
  MISformP22,
  MISformP23,
  MISformP24,
  MISformP25,
  MISformP26,
} from "../../../../core/data/json/MIS_Forms";
import {
  getOneMISApplicationDetails,
  submitApproveRejectMISApplication,
} from "../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import ApplicationTimelineModal from "../../../application/ApplicationTimeLineModal";

interface QueryComment {
  detailId: string;
  columnName: string;
  newValue: string | number;
  rowIndex: number;
  originalValue: string;
  comment: string;
}
const APP_STATUS_LEVEL_MAP: { [key: string]: string } = {
  "clerkAfterApproveAction": "This Report will be Approved",
  "pendingAtDrResubmission": "District Registrar",
  "pendingAtCoResubmission": "Cooperative Officer Marketing",
  "pendingAtClerkResubmission": "Junior Clerk",
  "pendingAtApmcSecretaryResubmission": "Secretary",
  "pendingAtApmcAccountantResubmission": "Accountant",
  "clerkAfterRejectionAction": "Junior Clerk",
  "pendingAtDr": "District Registrar",
  "pendingAtCo": "Cooperative Officer Marketing",
  "pendingAtClerk": "Junior Clerk",
};

const RaiseQueryPageMIS: React.FC = () => {
  const [applicationData, setApplicationData] = useState<any>([]);
  const [buttonData, setButtonData] = useState<any[]>([]);
  const [queries, setQueries] = useState<QueryComment[]>([]);
  const [selectedCell, setSelectedCell] = useState<{
    detailId: string;
    rowIndex: number;
    columnName: string;
    fieldValue: string;
    fieldLabel: string;
  } | null>(null);
  const [newValue, setNewValue] = useState<string | number>("");
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
const [pendingAction, setPendingAction] = useState<{ 
  status: string; 
  appStatusLevel: string; 
  buttonLabel: string 
} | null>(null);
  const [editComment, setEditComment] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [transaction, setTransaction] = useState<any[]>([]);
  const [comment, setComment] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const [editableFields, setEditableFields] = useState<Set<string>>(new Set());
  const [hasPrefetchedData, setHasPrefetchedData] = useState<boolean>(false);
  const [showAddRowModal, setShowAddRowModal] = useState(false);
  const [newRowData, setNewRowData] = useState<{
    [key: string]: string | number;
  }>({});
  const [newRowErrors, setNewRowErrors] = useState<{ [key: string]: string }>(
    {}
  );
  const [applicationStatus, setApplicationStatus] = useState<string>("");

  const navigate = useNavigate();
  const token = useSelector((state: any) => state.auth.token);
  const location = useLocation();
  const { applicationId, headerId, headerName } = location.state || {};

  const getDataField = (): any[]  => {
    const typeNum = headerId;
    switch (typeNum) {
      case "f8dd542e-637b-48a9-9579-c51d955958f6":
        return MISformP1;
      case "ff834af9-ec91-4b64-be9d-8d6431318d60":
        return MISformP2;
      case "03272304-d1c1-4de3-80d5-41cc38d92c4e":
        return MISformP3;
      case "4e3264d9-5849-48c2-adb8-8f365ca9b619":
        return MISformP4;
      case "d662fb80-e724-4295-84a7-2335043045e6":
        return MISformP5;
      case "4abc0a84-c79c-487e-9459-d5bfda288209":
        return MISformP6;
      case "3542455a-a9fe-44cb-b582-bc6645cabd13":
        return MISformP7;
      case "60f185c0-0e2f-45e8-8589-0ee7c5b30720":
        return MISformP8;
      case "e8e3723e-fc9c-42a8-8e93-8003fdfa384f":
        return MISformP9;
      case "19f2c32b-8727-4c56-bb5f-f2ddab040130":
        return MISformP10;
      case "c34fc166-a42d-4c35-9ce7-caf23b63cc38":
        return MISformP11;
      case "26d4a5d5-5ca2-4188-8469-1add4e7b798f":
        return MISformP12;
      case "03f686ae-0289-4567-abe4-611f054fc460":
        return MISformP13;
      case "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca":
        return MISformP14;
      case "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0":
        return MISformP15;
      case "d3732eaf-9f80-4fc3-8431-e53951c21e2a":
        return MISformP16;
      case "d1ac3935-3f20-4740-9538-f6a641a75496":
        return MISformP17;
      case "5985a467-617e-4feb-a33f-f40f947f2c0e":
        return MISformP18;
      case "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a":
        return MISformP19;
      case "204d4e1b-e3da-4bea-b011-c00de370ee82":
        return MISformP20;
      case "f1abc58d-2016-477e-92bf-ad2a68c83bc8":
        return MISformP21;
      case "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7":
        return MISformP22;
      case "e793e2b8-7f7c-489d-91af-70cbd2af1b3a":
        return MISformP23;
      case "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005":
        return MISformP24;
      case "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57":
        return MISformP25;
      case "35871e1f-26bc-4c6c-82cd-c5b8be6561f7":
        return MISformP26;
      default:
        return [];
    }
  };

  const misForm = getDataField();

  const fetchApplicationDetails = async () => {
    try {
      setLoading(true);
      const response = await getOneMISApplicationDetails(
        applicationId,
        headerId,
        token
      );
      if(response?.success === true && !response?.data?.buttonName){
        navigate("/mis-preview", {
          state: {
            applicationId: response?.data?.applicationId,
            headerId: headerId,
          },
        })
      }
      setApplicationData(response?.data);
      setTransaction(response?.data?.transaction || []);
      setButtonData(response?.data?.buttonName || []);
      setApplicationStatus(response?.data?.status || "");

      // NEW: Pre-fetch rejected fields after data is loaded
      // We'll do this in a separate useEffect to ensure data is ready
    } catch (error) {
     
      toast.error("Failed to fetch application details", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
  // Pre-populate queries from rejected fields
  useEffect(() => {
    if (
      applicationData?.details &&
      transaction.length > 0 &&
      (roleIdentifier === "SEC" || roleIdentifier === "ACCT") &&
      !hasPrefetchedData
    ) {
      const rejectedQueries = findRejectedFieldsForCurrentStatus();

      if (rejectedQueries.length > 0) {
        setQueries(rejectedQueries);
        setIsEditMode(true); // Enable edit mode by default

        toast.info(
          `Found ${rejectedQueries.length} field(s) that need correction. Only these fields can be edited.`,
          { position: "top-right", autoClose: 5000 }
        );
      }
    }
  }, [applicationData, transaction, roleIdentifier, hasPrefetchedData]);

  useEffect(() => {
    fetchApplicationDetails();
  }, []);

  const getFieldLabel = (columnName: string): string => {
    for (const field of misForm as any[]) {
      for (const resp of field.response) {
        if (resp.fieldName === columnName) {
          return (
            field.fieldVal +
            (field.response.length > 1 ? ` - ${resp.responseName}` : "")
          );
        }
      }
    }
    return columnName;
  };

  const parseValueType = (value: string): string => {
  return value.trim();
};

  const findRejectedFieldsForCurrentStatus = () => {
    let targetTransaction = null;
    let fieldsToProcess: any[] = [];
    let isRejectedFields = false;

    // Handle SEC role - look for rejectedFieldName
    if (roleIdentifier === "SEC") {
      targetTransaction = transaction.find(
        (t) => t.appStatusLevel === "pendingAtApmcSecretaryResubmission"
      );

      if (targetTransaction && targetTransaction.rejectedFieldName) {
        fieldsToProcess = targetTransaction.rejectedFieldName;
        isRejectedFields = true;
      }
    }

    // Handle ACCT role - look for reSubmittedFields
    if (roleIdentifier === "ACCT") {
      targetTransaction = transaction.find(
        (t) => t.appStatusLevel === "pendingAtApmcAccountantResubmission"
      );

      if (targetTransaction && targetTransaction.reSubmittedFields) {
        // Convert reSubmittedFields to array format
        fieldsToProcess = Array.isArray(targetTransaction.reSubmittedFields)
          ? targetTransaction.reSubmittedFields
          : Object.values(targetTransaction.reSubmittedFields).filter((f) => f);
        isRejectedFields = false;
      }
    }

    if (!targetTransaction || fieldsToProcess.length === 0) {
      return [];
    }

    const editableFieldSet = new Set<string>();

    const rejectedQueries: QueryComment[] = fieldsToProcess.map(
      (field: any) => {
        const detailRow = applicationData?.details?.find(
          (detail: any) =>
            detail.id === field.detailId || detail.id === field.id
        );

        // For reSubmittedFields, use the newValue from the field
        // For rejectedFieldName, use current value from detailRow
        const currentValue = isRejectedFields
          ? detailRow
            ? detailRow[field.columnName]
            : ""
          : field.newValue || "";

        const rowIndex =
          applicationData?.details?.findIndex(
            (detail: any) => detail.id === (field.detailId || field.id)
          ) || 0;

        // Add to editable fields set
        editableFieldSet.add(
          `${field.detailId || field.id}-${field.columnName}`
        );

        return {
          detailId: field.detailId || field.id,
          columnName: field.columnName,
          newValue: currentValue,
          rowIndex: rowIndex,
          originalValue: String(currentValue),
          comment: field.comment || "",
        };
      }
    );

    setEditableFields(editableFieldSet);
    setHasPrefetchedData(rejectedQueries.length > 0);

    return rejectedQueries;
  };

  const canAddNewRow = (): boolean => {
    return (
      (roleIdentifier === "ACCT") &&
      applicationStatus.toLowerCase().includes("resubmission")
    );
  };

  const initializeNewRow = () => {
    const emptyRow: { [key: string]: string | number } = {};

    misForm.forEach((field) => {
      field.response.forEach((resp) => {
        emptyRow[resp.fieldName] = "";
      });
    });

    setNewRowData(emptyRow);
    setNewRowErrors({});
  };

  const validateNewRow = (): boolean => {
    const errors: { [key: string]: string } = {};
    let isValid = true;

    misForm.forEach((field: any) => {
      field.response.forEach((resp: any) => {
        const value = newRowData[resp.fieldName];

        if (!value || String(value).trim() === "") {
          errors[resp.fieldName] = "This field is required";
          isValid = false;
        } else {
        const stringValue = String(value).trim();

        // Validate based on responseType from JSON
        if (resp.responseType === "number") {
          // Numeric validation
            const numericPattern = /^-?\d+\.?\d*$/;
            if (!numericPattern.test(stringValue)) {
              errors[resp.fieldName] = "This field must be a valid number";
              isValid = false;
            }
        } else if (resp.responseType === "select" && resp.options) {
          // Select validation - check if value is in options
          if (!resp.options.includes(stringValue)) {
            errors[resp.fieldName] = `Please select a valid option: ${resp.options.join(", ")}`;
            isValid = false;
          }
        }
        // responseType === "input" doesn't need additional validation beyond "required"
        }
      });
    });

    setNewRowErrors(errors);
    return isValid;
  };

  const handleNewRowFieldChange = (fieldName: string, value: string) => {
    setNewRowData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));

    // Clear error for this field
    if (newRowErrors[fieldName]) {
      setNewRowErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  const handleSaveNewRow = () => {
    if (!validateNewRow()) {
      toast.error("Please fill all fields correctly", {
        position: "top-right",
      });
      return;
    }

    // Convert values to proper types
    const processedRowData: { [key: string]: string | number } = {};

    Object.keys(newRowData).forEach((key) => {
      const value = String(newRowData[key]).trim();
      processedRowData[key] = parseValueType(value);
    });

    // Add to application data optimistically (for display)
    setApplicationData((prev: any) => ({
      ...prev,
      details: [
        ...(prev?.details || []),
        {
          id: `temp-${Date.now()}`, // Temporary ID
          ...processedRowData,
        },
      ],
    }));

    toast.success("New row added successfully", { position: "top-right" });
    setShowAddRowModal(false);
    setNewRowData({});
  };

const isFieldEditable = (detailId: string, columnName: string): boolean => {
    // Allow editing of newly added rows (temp IDs)
    if (String(detailId).startsWith("temp-")) {
      return isEditMode;
    }

    // If not SEC or ACCT role, follow normal edit mode logic
    if (roleIdentifier !== "SEC" && roleIdentifier !== "ACCT") {
      return isEditMode;
    }

    // If SEC/ACCT but no pre-fetched data, allow normal editing
    if (!hasPrefetchedData) {
      return isEditMode;
    }

    // If SEC/ACCT with pre-fetched data, only allow editing of rejected/resubmitted fields
    const fieldKey = `${detailId}-${columnName}`;
    return editableFields.has(fieldKey) && isEditMode;
  };

  const handleCellClick = (
    detailId: string,
    rowIndex: number,
    columnName: string,
    fieldValue: string
  ) => {
    if (!isFieldEditable(detailId, columnName)) {
      if (
        (roleIdentifier === "SEC" || roleIdentifier === "ACCT") &&
        hasPrefetchedData
      ) {
        toast.warning("Only fields marked for correction can be edited.", {
          position: "top-right",
        });
      } else if (!isEditMode) {
        toast.info("Please enable Edit/Comment Mode to Update/Comment.", {
          position: "top-right",
        });
      }
      return;
    }

    setSelectedCell({
      detailId,
      rowIndex,
      columnName,
      fieldValue,
      fieldLabel: getFieldLabel(columnName),
    });

    const existingQuery = queries.find(
      (q) => q.detailId === detailId && q.columnName === columnName
    );

    setNewValue(existingQuery?.newValue || fieldValue || "");
    setEditComment(existingQuery?.comment || "");
    setShowModal(true);
  };

  const handleSaveEdit = () => {
    if (!selectedCell) {
      toast.error("No cell selected", { position: "top-right" });
      return;
    }

    // const trimmedValue = String(newValue || "").trim();
    const trimmedValue = String(newValue || "").trim();
    const parsedValue = parseValueType(trimmedValue);
    const trimmedComment = String(editComment || "").trim();

    if (!trimmedValue) {
      toast.error("Please enter a value", { position: "top-right" });
      return;
    }

    if (!trimmedComment && roleIdentifier === "JC") {
      toast.error("Comment is Required", { position: "top-right" });
      return;
    }

    const newQuery: QueryComment = {
      detailId: selectedCell.detailId,
      columnName: selectedCell.columnName,
      newValue: parsedValue,
      rowIndex: selectedCell.rowIndex,
      originalValue: selectedCell.fieldValue,
      comment: trimmedComment,
    };

    setQueries((prev) => {
      const filtered = prev.filter(
        (q) =>
          !(
            q.detailId === selectedCell.detailId &&
            q.columnName === selectedCell.columnName
          )
      );
      return [...filtered, newQuery];
    });

    setShowModal(false);
    setNewValue("");
    setEditComment("");
    setSelectedCell(null);
    toast.success("Edit saved successfully", { position: "top-right" });
  };
  const handleButtonClick = (buttonConfig: any) => {
  // Run validations first
  if (roleIdentifier === "JC" && queries.length === 0) {
    toast.error("Please add at least one comment before submitting", { 
      position: "top-right" 
    });
    return;
  }

  if (!comment.trim()) {
    toast.error("Comment is Required", { position: "top-right" });
    return;
  }

  // If validations pass, show confirmation modal
  setPendingAction({
    status: buttonConfig.status,
    appStatusLevel: buttonConfig.appStatusLevel,
    buttonLabel: buttonConfig.buttonLabel
  });
  setShowConfirmModal(true);
};

const handleConfirmSubmit = () => {
  if (pendingAction) {
    setShowConfirmModal(false);
    const buttonConfig = {
      status: pendingAction.status,
      appStatusLevel: pendingAction.appStatusLevel,
      buttonLabel: pendingAction.buttonLabel
    };
    handleSubmit(buttonConfig);
    setPendingAction(null);
  }
};

const handleCancelSubmit = () => {
  setShowConfirmModal(false);
  setPendingAction(null);
};

  const handleSubmit = async (buttonConfig: any) => {
  let rejectedFieldName: any[] = [];
  let reSubmittedFields: any[] = [];
  let newFieldsAdded: any[] = [];

  if (roleIdentifier === "JC") {
    rejectedFieldName = queries.map((q) => ({
      id: q.detailId,
      columnName: q.columnName,
      comment: q.comment,
    }));
  } else {
    reSubmittedFields = queries.map((q) => ({
      detailId: q.detailId,
      columnName: q.columnName,
      newValue: q.newValue,
      comment: q.comment,
    }));
  }

  if (canAddNewRow() && applicationData?.details) {
    const newRows = applicationData.details.filter((detail: any) =>
      String(detail.id).startsWith("temp-")
    );

    if (newRows.length > 0) {
      newFieldsAdded = newRows
        .map((row: any) => {
          const rowFields: any[] = [];

          misForm.forEach((field) => {
            field.response.forEach((resp) => {
              if (row[resp.fieldName] !== undefined) {
                rowFields.push({
                  columnName: resp.fieldName,
                  newValue: row[resp.fieldName],
                });
              }
            });
          });

          return rowFields;
        })
        .flat();
    }
  }

  const formData = {
    headerId: headerId,
    applicationId: applicationId,
    status: buttonConfig.status,
    appStatusLevel: buttonConfig.appStatusLevel,
    comment: comment,
    rejectedFieldName: rejectedFieldName,
    reSubmittedFields: reSubmittedFields,
    newFieldsAdded: newFieldsAdded,
  };

  try {
    setUploading(true);
    const submitData = await submitApproveRejectMISApplication(
      formData,
      token
    );
    if (submitData.success) {
      toast.success("Form submitted successfully!", {
        position: "top-right",
      });
      setTimeout(() => {
        roleIdentifier==="ACCT" ? navigate("/mis-my-application") :roleIdentifier==="JC"? navigate("/mis-query-application"): navigate("/mis-pending-application");
      }, 1000);
    } else {
      toast.error("Submission failed, please try again.", {
        position: "top-right",
      });
    }

   
  } catch (error) {
    
    toast.error("An error occurred during submission", {
      position: "top-right",
    });
  } finally {
    setUploading(false);
  }
};



  const hasQuery = (detailId: string, columnName: string) => {
    return queries.some(
      (q) => q.detailId === detailId && q.columnName === columnName
    );
  };

  const toggleEditMode = () => {
    if (
      (roleIdentifier === "SEC" || roleIdentifier === "ACCT") &&
      hasPrefetchedData &&
      isEditMode
    ) {
      toast.warning(
        "Edit mode cannot be disabled when there are fields pending correction.",
        {
          position: "top-right",
        }
      );
      return;
    }

    if (isEditMode && queries.length > 0) {
      const confirmDisable = window.confirm(
        "You have unsaved changes. Disabling edit mode will not discard them. Continue?"
      );
      if (!confirmDisable) return;
    }

    setIsEditMode(!isEditMode);
    toast.success(
      roleIdentifier === "JC"
        ? isEditMode
          ? "Comment mode disabled"
          : "Comment mode enabled - Click on cells to comment"
        : isEditMode
        ? "Edit mode disabled"
        : "Edit mode enabled - Click on cells to edit",
      { position: "top-right" }
    );
  };

  return (
    <>
      {uploading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}
        >
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Submitting...</span>
            </div>
            <div className="fw-bold">Submitting, please wait...</div>
          </div>
        </div>
      )}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="mb-0">
              {headerName}
            </h3>
          </div>
          <div className="d-flex justify-content-end align-items-center mb-3">
            {!(
              (roleIdentifier === "SEC" || roleIdentifier === "ACCT") &&
              hasPrefetchedData
            ) && (
              <button
                className={`btn ${
                  isEditMode ? "btn-success" : "btn-success"
                }`}
                onClick={toggleEditMode}
              >
                <i
                  className={`me-2 ti ti-${isEditMode ? "lock-open" : "edit"}`}
                />
                {roleIdentifier === "JC"
                  ? isEditMode
                    ? "Comment Mode: ON"
                    : "Enable Comment Mode"
                  : isEditMode
                  ? "Edit Mode: ON"
                  : "Enable Edit Mode"}
              </button>
            )}

            {canAddNewRow() && (
              <button
                className="btn btn-info"
                onClick={() => {
                  initializeNewRow();
                  setShowAddRowModal(true);
                }}
              >
                <i className="me-2 ti ti-plus" />
                Add New Row
              </button>
            )}

            {showAddRowModal && (
              <>
                <div
                  className="modal show d-block"
                  tabIndex={-1}
                  style={{ overflowY: "auto" }}
                >
                  <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add New Row</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowAddRowModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="alert alert-info">
                          <strong>Note:</strong> All fields are required.
                          Numeric fields must contain valid numbers only.
                        </div>

                        <div className="row g-3">
                          {misForm.map((field: any, fieldIndex) => (
                            <React.Fragment key={fieldIndex}>
                              {field.response.map((resp: any, respIndex) => (
                                <div className="col-md-6" key={respIndex}>
                                  <label className="form-label fw-bold">
                                    {field.fieldVal}
                                    {field.response.length > 1 &&
                                      ` - ${resp.responseName}`}
                                    <span className="text-danger">*</span>
                                  </label>
                                {/* Render based on responseType */}
                                {resp.responseType === "select" && resp.options ? (
                                  // SELECT DROPDOWN
                                  <select
                                    className={`form-control ${
                                      newRowErrors[resp.fieldName] ? "is-invalid" : ""
                                    }`}
                                    value={String(newRowData[resp.fieldName] || "")}
                                    onChange={(e) =>
                                      handleNewRowFieldChange(resp.fieldName, e.target.value)
                                    }
                                  >
                                    <option value="">Select...</option>
                                    {resp.options.map((option: string, optIdx: number) => (
                                      <option key={optIdx} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  // INPUT or NUMBER FIELD
                                  <input
                                    type={resp.responseType === "number" ? "number" : "text"}
                                    className={`form-control ${
                                      newRowErrors[resp.fieldName]
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    value={String(
                                      newRowData[resp.fieldName] || ""
                                    )}
                                    onChange={(e) =>
                                      handleNewRowFieldChange(
                                        resp.fieldName,
                                        e.target.value
                                      )
                                    }
                                    placeholder={`Enter ${field.fieldVal}...`}
                                    step={resp.responseType === "number" ? "any" : undefined}
                                  />
                                )}
                                  {newRowErrors[resp.fieldName] && (
                                    <div className="invalid-feedback">
                                      {newRowErrors[resp.fieldName]}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => setShowAddRowModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSaveNewRow}
                        >
                          <i className="me-2 ti ti-check" />
                          Add Row
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-backdrop show"></div>
              </>
            )}
            </div>
          {/* 
        <div className={`alert ${isEditMode ? "alert-success" : "alert-info"} mb-4`}>
          <strong>Edit Mode:</strong> {isEditMode ? "Enabled" : "Disabled"} | 
          <strong className="ms-3">Changes Made:</strong> {queries.length}
          {isEditMode && <span className="ms-3 text-muted">(Click on any cell to edit)</span>}
        </div> */}
        <div className="mb-2 d-flex justify-content-end gap-2 align-items-center">
          <div className="rounded " style={{height:"10px", width:"10px", backgroundColor:"#ffe9a0ff"}}></div>
          <p className="fw-bold"> Modified</p>
        </div>

          <div className="table-responsive mb-4">
            <table className="table table-bordered table-hover">
              <thead className="table-dark border border-dark">
                <tr>
                  <th
                    rowSpan={2}
                    style={{ minWidth: "50px", verticalAlign: "middle", border: "1px solid black", }}
                  >
                    Sr.No.
                  </th>
                  {misForm.map((field, index) => (
                    <th
                      key={index}
                      colSpan={
                        field.response.length > 1
                          ? field.response.length
                          : undefined
                      }
                      rowSpan={field.response.length === 1 ? 2 : undefined}
                      style={{
                        minWidth: "150px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        verticalAlign: "middle",
                        border: "1px solid black"
                      }}
                    >
                      {field.fieldVal}
                    </th>
                  ))}
                </tr>
                <tr>
                  {misForm.map((field, fieldIndex) => (
                    <React.Fragment key={fieldIndex}>
                      {field.response.length > 1 &&
                        field.response.map((resp, respIndex) => (
                          <th
                            key={respIndex}
                            style={{
                              minWidth: "120px",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              textAlign: "center",
                              border: "1px solid black",
                            }}
                          >
                            {resp.responseName}
                          </th>
                        ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody>
                {applicationData?.details &&
                  applicationData.details.map((item: any, index: number) => (
                    <tr key={item.id}>
                      <td style={{ textAlign: "center",border: "1px solid black" }}>{index + 1}</td>
                      {misForm.map((field, fieldIndex) => (
                        <React.Fragment key={fieldIndex}>
                          {field.response.map((resp, respIndex) => {
                            const fieldValue =
                              item[resp.fieldName as keyof typeof item] || "-";
                            const isEdited = hasQuery(item.id, resp.fieldName);
                            const editedQuery = queries.find(
                              (q) =>
                                q.detailId === item.id &&
                                q.columnName === resp.fieldName
                            );

                            const isThisFieldEditable = isFieldEditable(
                              item.id,
                              resp.fieldName
                            );
                            const isDisabled =
                              (roleIdentifier === "SEC" ||
                                roleIdentifier === "ACCT") &&
                              hasPrefetchedData &&
                              !isThisFieldEditable;

                            return (
                              <td
                                key={respIndex}
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  padding: "0.75rem",
                                  border: "1px solid black",
                                  cursor: isThisFieldEditable
                                    ? "pointer"
                                    : "not-allowed",
                                  backgroundColor: isEdited
                                    ? "#fff3cd"
                                    : isDisabled
                                    ? "#f0f0f0"
                                    : "transparent",
                                  opacity: isDisabled ? 0.6 : 1,
                                  transition: "background-color 0.2s",
                                  position: "relative",
                                }}
                                onClick={() =>
                                  handleCellClick(
                                    item.id,
                                    index,
                                    resp.fieldName,
                                    fieldValue
                                  )
                                }
                                title={
                                  isDisabled
                                    ? "This field cannot be edited"
                                    : isEdited
                                    ? `Click to edit | Comment: ${editedQuery?.comment}`
                                    : isEditMode
                                    ? "Click to edit"
                                    : "Enable edit mode to modify"
                                }
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <span>
                                    {isEdited
                                      ? String(editedQuery?.newValue)
                                      : fieldValue}
                                  </span>
                                  {isEdited && (
                                    <i
                                      className=" text-warning ms-2"
                                      style={{ fontSize: "1.1rem" }}
                                      title={`Needs correction: ${editedQuery?.comment}`}
                                    />
                                  )}
                                  {isDisabled && (
                                    <i
                                      className="ti ti-lock text-muted ms-2"
                                      style={{ fontSize: "0.9rem" }}
                                    />
                                  )}
                                </div>
                              </td>
                            );
                          })}
                        </React.Fragment>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {queries.length > 0 && (
            <div className="card mb-4">
              <div className="card-header bg-gray">
                <h5 className="mb-0">Pending Changes ({queries.length})</h5>
              </div>
              <div className="card-body">
                <div className="list-group">
                  {queries.map((query, idx) => {
                    // Check if original and new values are different
                    const hasValueChanged = String(query.originalValue) !== String(query.newValue);
                    
                    return (
                      <div key={idx} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <h6 className="mb-1">Row {query.rowIndex + 1}</h6>
                            <p className="mb-1">
                              <strong>Field:</strong>{" "}
                              {getFieldLabel(query.columnName)}
                            </p>
                            
                            {/* Show original value only if value has changed */}
                            {hasValueChanged && (
                              <p className="mb-1">
                                <strong>Original Value:</strong>{" "}
                                {query.originalValue || "-"}
                              </p>
                            )}
                            
                            {!(roleIdentifier === "JC") ? (
                              <p className="mb-0 text-success">
                                <strong>{hasValueChanged ? "New Value" : "Value"}:</strong>{" "}
                                {String(query.newValue)}
                              </p>
                            ) : (
                              <p className="mb-0 text-info mt-1">
                                <strong>Comment:</strong> {query.comment}
                              </p>
                            )}
                            
                            {query.comment && (roleIdentifier === "SEC" || roleIdentifier === "ACCT") && (
                              <p className="mb-0 text-muted mt-1">
                                <strong>Comment:</strong> {query.comment}
                              </p>
                            )}
                          </div>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {
                              setQueries((prev) =>
                                prev.filter((_, i) => i !== idx)
                              );
                              toast.info("Change removed", {
                                position: "top-right",
                              });
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          <div className="mb-3">
            <label className="form-label fw-bold">Comment</label>
            <textarea
              className="form-control"
              placeholder="Enter your comment about the changes..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={4}
            />
          </div>

          {transaction && transaction.length > 0 && (
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#comment_modal"
              className="btn btn-primary mb-3"
            >
              <i className="me-2 ti ti-file-description" />
              View Application Timeline
            </button>
          )}

          <div className="d-flex gap-3 mb-4">
            {buttonData.map((button, index) => {
              const isRaiseQuery = button.buttonLabel
                .toLowerCase()
                .includes("accountant");
              const buttonClass = isRaiseQuery ? "btn-primary" : "btn-success";

              return (
                <button
                  key={index}
                  className={`btn ${buttonClass} btn-lg`}
                  onClick={() => handleButtonClick(button)}
                  disabled={isRaiseQuery && queries.length === 0}
                >
                  <i className="me-2 ti ti-send" />
                  {button.buttonLabel}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {showModal && (
        <>
          <div className="modal show d-block" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Field Value</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Field:</label>
                    <p className="text-muted">{selectedCell?.fieldLabel}</p>
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Current Value:</label>
                    <p className="text-muted">
                      {selectedCell?.fieldValue || "-"}
                    </p>
                  </div>
                  {!(roleIdentifier === "JC") ? (
                    <div className="mb-3">
                      <label className="form-label fw-bold">New Value:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={String(newValue)}
                        onChange={(e) => setNewValue(e.target.value)}
                        placeholder="Enter new value..."
                        autoFocus
                      />
                    </div>
                  ):(
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Comment (Min 3 words):
                    </label>
                    <textarea
                      className="form-control"
                      value={editComment}
                      onChange={(e) => setEditComment(e.target.value)}
                      placeholder="Enter reason for this change..."
                      rows={3}
                    />
                  </div>
                  )}
                  {
                    (editComment && (roleIdentifier === "SEC" || roleIdentifier === "ACCT")) && (
                      <p><strong>Comment:</strong> {editComment}</p>
                    )
                  }
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary me-3"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveEdit}
                  >
                    Save Change
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}

      <ApplicationTimelineModal comments={transaction} />
      {/* Confirmation Modal */}
{showConfirmModal && (
  <div 
    className="modal fade show" 
    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
    tabIndex={-1}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirm Submission</h5>
          <button 
            type="button" 
            className="btn-close" 
            onClick={handleCancelSubmit}
          />
        </div>
        <div className="modal-body">
          <p className="mb-2">Are you sure you want to forward this application?</p>
          {pendingAction && (
            <p className="text-muted">
              {pendingAction.appStatusLevel === "clerkAfterApproveAction" ? (
                <strong>{APP_STATUS_LEVEL_MAP[pendingAction.appStatusLevel]}</strong>
              ) : (
                <>
                  This application will be forwarded to <strong>{APP_STATUS_LEVEL_MAP[pendingAction.appStatusLevel] || pendingAction.appStatusLevel}</strong>
                </>
              )}
            </p>
          )}
        </div>
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-secondary me-3" 
            onClick={handleCancelSubmit}
          >
            No
          </button>
          <button 
            type="button" 
            className="btn btn-primary" 
            onClick={handleConfirmSubmit}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default RaiseQueryPageMIS;
